/**
 * Centralized Logger — Production-Safe Logging
 *
 * Provides gated logging that only outputs in development mode.
 * Prevents console spam in production while maintaining error visibility.
 */

const IS_DEV = process.env.NODE_ENV === 'development';

/**
 * Debug logging - only in development
 */
export function debug(...args: any[]): void {
  if (IS_DEV) {
    console.log('[DEBUG]', ...args);
  }
}

/**
 * Info logging - gated, can be enabled in production if needed
 */
export function info(...args: any[]): void {
  if (IS_DEV) {
    console.log('[INFO]', ...args);
  }
}

/**
 * Warning logging - always allowed
 */
export function warn(...args: any[]): void {
  console.warn('[WARN]', ...args);
}

/**
 * Error logging - always allowed
 */
export function error(...args: any[]): void {
  console.error('[ERROR]', ...args);
}

/**
 * Group logging - only in development
 */
export function group(label: string): void {
  if (IS_DEV) {
    console.group(label);
  }
}

/**
 * End group - only in development
 */
export function groupEnd(): void {
  if (IS_DEV) {
    console.groupEnd();
  }
}

/**
 * Safe JSON parse with fallback
 */
export function safeJsonParse<T>(json: string, fallback: T, context?: string): T {
  try {
    return JSON.parse(json) as T;
  } catch (err) {
    error(`Failed to parse JSON${context ? ` (${context})` : ''}:`, err);
    return fallback;
  }
}